import { render, staticRenderFns } from "./DetalhesEmpresa.vue?vue&type=template&id=b877226c&"
import script from "./DetalhesEmpresa.vue?vue&type=script&lang=js&"
export * from "./DetalhesEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports